import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./ProgressBarChunk.module.scss";
export const ProgressBarChunk = ({ isFilled, isFirst, isLast, className }) => {
    return (_jsx("div", { "data-testid": "progressBarChunk", className: classNames(styles.progressBarChunk, "light-theme", className, {
            [styles.progressBarChunkFilled]: isFilled,
            [styles.progressBarChunkFirst]: isFirst,
            [styles.progressBarChunkLast]: isLast,
        }) }));
};
//# sourceMappingURL=ProgressBarChunk.js.map